import { ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';

//

@Component({
  selector: 'cnc-auth-recover',
  templateUrl: './auth-recover.component.html',
  styleUrls: ['./auth-recover.component.scss'],
})
export class AuthRecoverComponent implements OnInit {
  @HostBinding('class') _hostClass = 'lum-login-body';

  validToken :boolean = false;
  hide :boolean = true;
  loading :boolean = false;
  recoverForm :UntypedFormGroup;
  decodedData :any;
  token :any;

  constructor(
    private auth :AuthService,
    private route :ActivatedRoute,
    private fb :UntypedFormBuilder,
    private cdr :ChangeDetectorRef,
    private router :Router,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.tk) {
        if (this.auth.isTokenValid(params.tk)) {
          this.token = params.tk;
          this.validToken = true;
          this.decodedData = this.auth.decodeToken(params.tk);
        }
      }
    });
    this.recoverForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  handleSubmit(e :SubmitEvent) {
    e.preventDefault();

    this.#submit();
  }

  isControlHasError(controlName :string, validationType :string) :boolean {
    const control = this.recoverForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result =
      control.hasError(validationType) && (control.dirty || control.touched);

    return result;
  }

  #submit() {
    const data = this.recoverForm.value;
    if (!this.recoverForm.valid) {
      Swal.fire({
        title: 'Form Error!',
        text: 'Please fill the all the required fields.',
        type: 'error',
        confirmButtonText: 'Okay',
      });

      return;
    }
    const credentials = {
      email: this.decodedData.user,
      password: data.password,
      token: this.token,
    };
    this.loading = true;
    this.auth.savePassword(credentials).subscribe(
      (data) => {
        this.loading = false;
        this.cdr.markForCheck();
        Swal.fire({
          title: 'Password Saved!',
          text: data.message,
          type: 'success',
          confirmButtonText: 'Okay',
        }).then(() => {
          this.router.navigateByUrl('/auth/login');
        });
      },
      (error) => {
        this.loading = false;
        this.cdr.markForCheck();
      },
    );
  }
}
